// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".queue-legend {\n\twidth: 14px;\n    height: 11px;\n    margin-right: 7px;\n    margin-bottom: 4px;\n}", "",{"version":3,"sources":["webpack://src/components/Dash/QueueLegend/index.css"],"names":[],"mappings":"AAAA;CACC,WAAW;IACR,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".queue-legend {\n\twidth: 14px;\n    height: 11px;\n    margin-right: 7px;\n    margin-bottom: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
